<script>
import ClubNewsCard from "@/components/HomePageView/ClubNewsCard.vue";
import {useNewsItemStore} from "@/store/news-items";
import {computed} from "vue";

export default {
  name: "ClubNews",
  components: {ClubNewsCard},
  setup() {
    const newsItemStore = useNewsItemStore();
    const clubNews = computed(() => {
      return newsItemStore.items;
    })
    return {clubNews}
  }
}
</script>

<template>
  <div class="clubNews">
    <span class="clubNews__header">КЛУБ</span>
    <ClubNewsCard
        v-for="clubNewsItem in clubNews"
        :key="clubNewsItem.id"
        :news-item = "clubNewsItem"
    >
    </ClubNewsCard>
  </div>
</template>

<style scoped lang="scss">
.clubNews {
  text-align: left;
  display: inline-flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  gap: 20px;
  &__header {
    color: var(--cd-text-muted);
  }
}
</style>
